import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=8a7f45c2&scoped=true"
import script from "./supervision.vue?vue&type=script&lang=js"
export * from "./supervision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f45c2",
  null
  
)

export default component.exports